import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, invalid, ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={cn(
          "h-11 w-full rounded-md px-3.5 text-[15px] font-sans",
          "bg-bg-elevated text-ink placeholder:text-ink-subtle",
          "border border-line-strong outline-none",
          "transition-[border-color,box-shadow] duration-200",
          "focus:border-primary focus:shadow-[0_0_0_2px_color-mix(in_oklab,var(--primary)_25%,transparent)]",
          "disabled:opacity-50 disabled:cursor-not-allowed",
          invalid && "border-danger focus:border-danger focus:shadow-[0_0_0_2px_color-mix(in_oklab,var(--danger)_25%,transparent)]",
          className,
        )}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";
